<template>
  <span :class="formatedValueClass">{{ formatedValue }}</span>
</template>

<script>
export default {
  name: "AmountDigitText",
  props: {
    value: {
      type: [Number, String],
      default: '',
    },
    precision: Number,
  },
  computed: {
    formatedValue() {
      return this.$utils.amountDigitFn(this.value, this.precision);
    },
    formatedValueClass(){
      return this.formatedValue > 0 ? 'red':'green'
    }
  },
};
</script>

<style lang="scss" scoped>
.red{
  color:red;
}
.green{
  color:green;
}
</style>
